import { render, staticRenderFns } from "./KeywordImportedRenderer.vue?vue&type=template&id=20169d7d&scoped=true&"
import script from "./KeywordImportedRenderer.vue?vue&type=script&lang=js&"
export * from "./KeywordImportedRenderer.vue?vue&type=script&lang=js&"
import style0 from "./KeywordImportedRenderer.vue?vue&type=style&index=0&id=20169d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20169d7d",
  null
  
)

/* custom blocks */
import block0 from "./KeywordImportedRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports